import { useState, useEffect } from "react";
import { Form, Spin, Tabs, Row, Col, Input, Button, Select, DatePicker, Checkbox } from "antd";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScale, faClockRotateLeft, faGift, faHandHoldingDollar, faHandshake, faIdCard, faIdCardAlt, faPiggyBank } from '@fortawesome/free-solid-svg-icons';

import dayjs from 'dayjs';

import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { brToNumber, inverterEstruturaConvenio, isStateValid, onlyNumbers, pushToBase, resetColor } from "../../../utils/utilsFunctions";

import type { SimpleDropdownItem, ICtrlDoc, IDocumento, IEnum, IPlanoBeneficios, IBeneficio, ISelectList, ITipo, ITipoComponenteResgatePortabilidade, IInstituto, IEfpc, IConvenio, IConvenenteComConvenio } from "../../../components/Interfaces";

import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail, infoMessage } from "../../../messages/messages";
import { apiConvenio, apiPlanosBeneficios, type IErroApi } from "../../../services/api";

import { useLocation, useParams } from "react-router";
import CadInfoBotoes from "../../../components/CadInfoBotoes";
import { carregaListaDocumento, carregaListaFundamentacaoLegal, carregaListaCaracteristica, carregaListaModalidade, carregaListaTipoRegulamento, carregaListaTipoBeneficio, carregaListaRegimeFinanceiro, carregaListaMetodoFinanciamento, carregaListaTipoExpressaoBeneficio, carregaListaPrazoPagamento, carregaListaTipoRegraCalculo, carregaListaTipoRequisitoElegibilidade, carregaListaTipoComponenteResgatePortabilidade, carregaListaTipoInstituto, carregaListaUnidadeMedidaPercentualMonetario, carregaListaUnidadeMedidaPrazo } from "../../PessoaJuridica/services";
import { maskCNPB, maskCnpj, maskCurrency, maskNumeroProcesso } from "../../../utils/maskFunctions";
import FormModalDocumento from "../../../components/FormModalDocumento";
import type { CheckboxProps, TabsProps } from "antd/lib";
import { PatternFormat } from "react-number-format";
import FormContribuicao from "../components/FormContribuicao";
import Beneficio from "../components/Beneficio";
import Instituto from "../components/Instituto";
import TextArea from "antd/es/input/TextArea";
import ModalEfpc from "../../Efpc/Componentes/ModalEfpc";
import ListarConveniosAdesao from "../components/ListarConveniosAdesao";
import ListarConvenentesConvenioAdesao from "../components/ListarConvenentesConveniosAdesao";


const Manter = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { tipo } = useParams();

  const [form] = Form.useForm();

  const [manter, setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")

  const [listFundamentacaoLegal, setListFundamentacaoLegal] = useState<ISelectList[]>([]);
  const [listCaracteristicas, setListCaracteristicas] = useState<ISelectList[]>([]);
  const [listModalidades, setListModalidades] = useState<ISelectList[]>([]);
  const [listUnidadesMedidaContribuicaoMinima, setListUnidadesMedidaContribuicaoMinima] = useState<ISelectList[]>([]);
  const [listUnidadesMedidaCarencia, setListUnidadesMedidaCarencia] = useState<ISelectList[]>([]);
  const [listRegimeFinanceiro, setListRegimeFinanceiro] = useState<ISelectList[]>([]);
  const [listMetodoFinanciamento, setListMetodoFinanciamento] = useState<ISelectList[]>([]);
  const [listTipoExpressaoBeneficio, setListTipoExpressaoBeneficio] = useState<ISelectList[]>([]);
  const [listPrazoPagamento, setListPrazoPagamento] = useState<ISelectList[]>([]);
  const [listTipoRegulamento, setListTipoRegulamento] = useState<ISelectList[]>([]);
  const [listTipoBeneficio, setListTipoBeneficio] = useState<ITipo[]>([]);
  const [listTipoInstituto, setListTipoInstituto] = useState<ITipo[]>([]);
  const [listTipoComponenteResgatePortabilidade, setListTipoComponenteResgatePortabilidade] = useState<ITipoComponenteResgatePortabilidade[]>([]);
  const [listTipoRegraCalculo, setListTipoRegraCalculo] = useState<SimpleDropdownItem[]>([]);
  const [listTipoRequisitoElegibilidade, setListTipoRequisitoElegibilidade] = useState<SimpleDropdownItem[]>([]);

  const [listDocumentoRegulamentoPlano, setListDocumentoRegulamentoPlano] = useState<ISelectList[]>([]);
  const [ctrlDocRegulamentoPlano, setCtrlDocRegulamentoPlano] = useState<ICtrlDoc[]>([]);
  const [listDocumentosOutrosPlano, setListDocumentosOutrosPlano] = useState<ISelectList[]>([]);
  const [ctrlDocsOutrosPlano, setCtrlDocsOutrosPlano] = useState<ICtrlDoc[]>([]);
  const [listDocumentosAnalise, setListDocumentosAnalise] = useState<ISelectList[]>([]);
  const [ctrlDocsAnalisePlano, setCtrlDocsAnalisePlano] = useState<ICtrlDoc[]>([]);

  // const [planoRetPosCadastro, setPlanoRetPosCadastro] = useState<IPlanoBeneficios>();
  const [planoRecebido, setPlanoRecebido] = useState<IPlanoBeneficios>(); // REGISTRA OS DADOS ORIGINAIS RECEBIDOS NA ENTRADA DA PÁGINA
  const [dadosPlano, setDadosPlano] = useState<IPlanoBeneficios>();


  const [beneficios, setBeneficios] = useState<IBeneficio[]>([]);
  const [institutos, setInstitutos] = useState<IInstituto[]>([]);
  const [convenios, setConvenios] = useState<IConvenio[]>([]);
  const [convenentesComConvenios, setConvenentesComConvenios] = useState<IConvenenteComConvenio[]>([]);

  const [documentos, setDocumentos] = useState<IDocumento[]>([]);

  const [planoRegulamentoDocumento, setPlanoRegulamentoDocumento] = useState<IDocumento[]>([]);
  const [documentosRegulamentosHistoricos, setDocumentosRegulamentosHistoricos] = useState<IDocumento[]>([]);
  const [nmTipoRegulamento, setNmTipoRegulamento] = useState("");

  const [planoDocumentoOutros, setPlanoDocumentoOutros] = useState<IDocumento[]>([]);
  const [planoDocumentoAnalise, setPlanoDocumentoAnalise] = useState<IDocumento[]>([]);

  const [sigla, setSigla] = useState("");
  const [fundamentacaoLegal, setFundamentacaoLegal] = useState(-1);
  const [caracteristica, setCaracteristica] = useState(0);
  const [modalidade, setModalidade] = useState(0);
  const [permiteAdesaoDependente, setPermiteAdesaoDependente] = useState(false);
  const [preveInscricaoAutomatica, setPreveInscricaoAutomatica] = useState(false);
  const [tipoRegulamento, setTipoRegulamento] = useState(0);
  const [codigoModelo, setCodigoModelo] = useState("");
  const [contribuicaoNormalParticipante, setContribuicaoNormalParticipante] = useState(false);
  const [contribuicaoNormalAssistido, setContribuicaoNormalAssistido] = useState(false);
  const [contribuicaoNormalPatrocinador, setContribuicaoNormalPatrocinador] = useState(false);
  const [contribuicaoDespesaAdministrativaParticipante, setContribuicaoDespesaAdministrativaParticipante] = useState(false);
  const [contribuicaoDespesaAdministrativaAssistido, setContribuicaoDespesaAdministrativaAssistido] = useState(false);
  const [contribuicaoDespesaAdministrativaPatrocinador, setContribuicaoDespesaAdministrativaPatrocinador] = useState(false);
  const [indicadorPrevidencial, setIndicadorPrevidencial] = useState(true);
  const [limiteMaximoSalario, setLimiteMaximoSalario] = useState(false);
  const [contribuicaoServicoPassadoParticipante, setContribuicaoServicoPassadoParticipante] = useState(false);
  const [contribuicaoServicoPassadoAssistido, setContribuicaoServicoPassadoAssistido] = useState(false);
  const [contribuicaoServicoPassadoPatrocinador, setContribuicaoServicoPassadoPatrocinador] = useState(false);
  const [preveContribuicaoMinima, setPreveContribuicaoMinima] = useState(false);
  const [contribuicaoMinima, setContribuicaoMinima] = useState("");
  const [unidadeMedidaContribuicaoMinima, setUnidadeMedidaContribuicaoMinima] = useState(0);
  const [ofereceResgateParcial, setOfereceResgateParcial] = useState(false);

  const [mostrarDetalhesEfpc, setMostrarDetalhesEfpc] = useState(false)
  const [dadosEfpc, setDadosEfpc] = useState<IEfpc>()
  const [numeroProcessoPlanoFormato, setNumeroProcessoPlanoFormato] = useState("#####.######/####-##")
  const [numeroProcessoEfpcFormato, setNumeroProcessoEfpcFormato] = useState("#####.######/####-##")

  useEffect(() => {
    window.scrollTo(0, 0)

    setLoading(true);
    const carregaDadosIniciais = async () => {
      carregaListaFundamentacaoLegalOpcoes();
      carregaListaCaracteristicasOpcoes();
      carregaListaModalidadesOpcoes();
      carregaListaUnidadesMedidaPercentualMonetarioOpcoes();
      carregaListaUnidadesMedidaPrazoOpcoes();
      carregaListaTiposRegulamentosOpcoes();

      carregaListaDocumentoRegulamentoOpcoes();
      carregaListaDocumentosOutrosPlanoOpcoes();
      carregaListaDocumentosAnaliseOpcoes();

      carregaListaTiposBeneficiosOpcoes();
      carregaListaRegimeFinanceiroOpcoes();
      carregaListaMetodoFinanciamentoOpcoes();
      carregaListaTipoExpressaoBeneficioOpcoes();
      carregaListaPrazoPagamentoOpcoes();

      carregaListaTiposRegrasCalculosOpcoes();
      carregaListaTiposRequisitosElegibilidadeOpcoes();

      carregaListaTiposInstitutosOpcoes();
      carregaListaTiposComponentesResgatePortabilidadeOpcoes();

    }
    carregaDadosIniciais();
    setLoading(false);

    if (isStateValid(state)) {
      if (!tipo) {
        validaPlanoRecebidoViaStatus(state.data);
      } else {
        errorMessage("Erro sistémico. Este modo não deveria receber dados via 'state'.");
        pushToBase(navigate);
      }
      setManter(state.manter);
    }

  }, []);

  useEffect(() => {
    if (manter === -2) { // edição cancelada
      setDadosPlano(undefined); // LIMPA OS DADOS
      setManter(2); // MUDA PARA O ESTADO DETALHAR
    }

    if (manter === 2) {
      if (!dadosPlano) setDadosPlano(planoRecebido); // RETORNA COM OS DADOS ORIGINAIS RECEVIDOS VIA STATUS OU VIA RESPONSE
    }


    if (manter === 3) {
      validarVersionar()
    }
  }, [manter]);

  useEffect(() => {
    if (documentos) {
      setPlanoRegulamentoDocumento(documentos.filter(doc => (BigInt(doc.bitwise || 0) & 1126999418470400n) === 1126999418470400n)); // DOCUMENTOS DO PLANO
      setPlanoDocumentoOutros(documentos.filter(doc => (BigInt(doc.bitwise || 0) & 2252899325313024n) === 2252899325313024n)); // DOCUMENTOS DA ENTIDADE OUTROS
      setPlanoDocumentoAnalise(documentos.filter(doc => (BigInt(doc.bitwise || 0) & 4504699138998272n) === 4504699138998272n)); // DOCUMENTOS DA ENTIDADE ANÁLISE
    }
  }, [documentos]);

  useEffect(() => {
    if (mostrarDetalhesEfpc && !dadosEfpc) {
      setDadosEfpc(dadosPlano?.efpc);
    }
  }, [mostrarDetalhesEfpc]);

  useEffect(() => {
    if (convenios && convenios.length > 0) {
      setConvenentesComConvenios(inverterEstruturaConvenio(convenios));
    }
  }, [convenios]);

  useEffect(() => {
    if (tipoRegulamento) {
      let localNmRegulamento = listTipoRegulamento.find(f => f.value === tipoRegulamento)?.label;
      if (localNmRegulamento && localNmRegulamento !== "")
        setNmTipoRegulamento(localNmRegulamento);
    }
  }, [tipoRegulamento]);

  useEffect(() => {
    if (!preveContribuicaoMinima) {
      form.setFieldsValue({
        contribuicaoMinima: undefined,
        nmUnidadeMedidaContribuicaoMinima: undefined,
      });
      setContribuicaoMinima("");
      setUnidadeMedidaContribuicaoMinima(0);
    }
  }, [preveContribuicaoMinima]);

  useEffect(() => {

    if (dadosPlano && listCaracteristicas.length > 0 && listTipoRegulamento.length > 0
      && listModalidades.length > 0 && listFundamentacaoLegal.length > 0
      && listUnidadesMedidaContribuicaoMinima.length > 0 && listTipoInstituto.length > 0
    ) {
      setPlanoRecebido(dadosPlano);
      setSigla(dadosPlano.sigla);
      setFundamentacaoLegal(dadosPlano.fundamentacaoLegal);
      setCaracteristica(dadosPlano.caracteristica);
      setModalidade(dadosPlano.modalidade);
      setPermiteAdesaoDependente(dadosPlano.permiteAdesaoDependente);
      setPreveInscricaoAutomatica(dadosPlano.preveInscricaoAutomatica);
      setTipoRegulamento(dadosPlano.tipoRegulamento);
      setCodigoModelo(dadosPlano.codigoModelo || "");
      setContribuicaoNormalParticipante(dadosPlano.contribuicaoNormalParticipante);
      setContribuicaoNormalAssistido(dadosPlano.contribuicaoNormalAssistido);
      setContribuicaoNormalPatrocinador(dadosPlano.contribuicaoNormalPatrocinador);
      setContribuicaoDespesaAdministrativaParticipante(dadosPlano.contribuicaoDespesaAdministrativaParticipante);
      setContribuicaoDespesaAdministrativaAssistido(dadosPlano.contribuicaoDespesaAdministrativaAssistido);
      setContribuicaoDespesaAdministrativaPatrocinador(dadosPlano.contribuicaoDespesaAdministrativaPatrocinador);
      setIndicadorPrevidencial(dadosPlano.indicadorPrevidencial);
      setLimiteMaximoSalario(dadosPlano.limiteMaximoSalario);
      setContribuicaoServicoPassadoParticipante(dadosPlano.contribuicaoServicoPassadoParticipante);
      setContribuicaoServicoPassadoAssistido(dadosPlano.contribuicaoServicoPassadoAssistido);
      setContribuicaoServicoPassadoPatrocinador(dadosPlano.contribuicaoServicoPassadoPatrocinador);
      setPreveContribuicaoMinima(dadosPlano.preveContribuicaoMinima);
      setContribuicaoMinima(dadosPlano.contribuicaoMinima ? maskCurrency(dadosPlano.contribuicaoMinima) : "");
      setUnidadeMedidaContribuicaoMinima(dadosPlano.unidadeMedidaContribuicaoMinima || 0);
      setOfereceResgateParcial(dadosPlano.ofereceResgateParcial);

      setBeneficios(dadosPlano.beneficios);

      carregaListaConvenioDeAdesao();

      setDocumentos(dadosPlano.documentos);
      if (dadosPlano.documentosRegulamentosHistoricos)
        setDocumentosRegulamentosHistoricos(dadosPlano.documentosRegulamentosHistoricos);

      // Acrescenta o tipoInstitutoNome e depois Coloca os institutos em ordem alfabética e depois coloca o resgate parcial, se existir, no fim da lista de institutos
      let institutosSortedList = (
        dadosPlano.institutos
          .map(i => ({
            ...i,
            tipoInstitutoNome: listTipoInstituto.find(l => l.id === i.tipoInstitutoId)?.nome,
            tableKey: i.resgateParcial ? "resgateParcial" : i.tipoInstitutoId,
          }))
          .sort((a, b) => (a.tipoInstitutoNome ? a.tipoInstitutoNome : "").localeCompare(b.tipoInstitutoNome ? b.tipoInstitutoNome : ""))
      );

      let resgateParcialItem: any = [];
      resgateParcialItem = institutosSortedList.find(i => i.resgateParcial);
      let newList: any = {};

      if (resgateParcialItem) {
        newList = [...institutosSortedList.filter(i => !i.resgateParcial), resgateParcialItem];
        setInstitutos(newList);
      } else {
        setInstitutos(institutosSortedList);
      }

      if (dadosPlano.pessoaJuridicaPlano?.numeroProcesso?.length !== 15)
        setNumeroProcessoPlanoFormato("####################");

      if (dadosPlano.efpc?.pessoaJuridicaEfpc?.numeroProcesso?.length !== 15)
        setNumeroProcessoEfpcFormato("####################");

      form.setFieldsValue({
        efpcNumeroEfpcCnpj: dadosPlano.efpc?.numeroPessoaJuridica,
        efpcNumeroProcesso: maskNumeroProcesso(dadosPlano.efpc?.pessoaJuridicaEfpc?.numeroProcesso),
        efpcRazaoSocial: dadosPlano.efpc?.pessoaJuridicaEfpc?.razaoSocial,

        planoNumeroEfpcCnpj: dadosPlano.pessoaJuridicaPlano?.tipoIdentificador === 1 ? dadosPlano.pessoaJuridicaPlano.numero : undefined,
        planoNumeroEfpcProcesso: dadosPlano.pessoaJuridicaPlano?.tipoIdentificador === 3 ? dadosPlano.pessoaJuridicaPlano?.numero : undefined,

        numeroProcesso: dadosPlano.pessoaJuridicaPlano?.numeroProcesso,

        nmSituacao: dadosPlano.situacaoAtualPlano + (dadosPlano.situacaoAtualSecundariaPlano ? " - " + dadosPlano.situacaoAtualSecundariaPlano : ""),
        dataSituacao: dadosPlano.dataVigencia ? dayjs(dadosPlano.dataVigencia).format('DD/MM/YYYY') : undefined,

        dataAutorizacao: dadosPlano.dataAutorizacao ? dayjs(dadosPlano.dataAutorizacao).format("DD/MM/YYYY") : undefined,
        nome: dadosPlano.nome,
        numero: maskCNPB(dadosPlano.numero),
        sigla: dadosPlano.sigla.toUpperCase(),
        nmCaracteristica: listCaracteristicas.find(l => l.value === dadosPlano.caracteristica)?.label,
        nmModalidade: listModalidades.find(l => l.value === dadosPlano.modalidade)?.label,
        nmFundamentacaoLegal: listFundamentacaoLegal.find(l => l.value === dadosPlano.fundamentacaoLegal)?.label,

        nmTpRegulamento: listTipoRegulamento.find(l => l.value === dadosPlano.tipoRegulamento)?.label,
        codigoModelo: dadosPlano.codigoModelo?.toUpperCase(),
        contribuicaoMinima: dadosPlano.contribuicaoMinima ? maskCurrency(dadosPlano.contribuicaoMinima) : undefined,
        nmUnidadeMedidaContribuicaoMinima: listUnidadesMedidaContribuicaoMinima.find(l => l.value === dadosPlano.unidadeMedidaContribuicaoMinima)?.label,

        dataInicioFuncionamento: dadosPlano.dataInicioFuncionamento ? dayjs(dadosPlano.dataInicioFuncionamento) : undefined,

      });
    }
  }, [dadosPlano, listCaracteristicas, listTipoRegulamento, listModalidades, listFundamentacaoLegal, listUnidadesMedidaContribuicaoMinima, listTipoInstituto]);

  function validaPlanoRecebidoViaStatus(plano: IPlanoBeneficios) {
    if (!plano || plano.serie <= 0) {
      errorMessage("Plano de Benefícios não identificado");
      pushToBase(navigate);
    } else {
      setDadosPlano(plano)
    }
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const validarPlanoBeneficio = () => {

    if (!institutos || institutos.length < 4) {
      errorMessage("Institutos inválidos. Deveriam constar ao menos 4.");
      return;
    }

    if (!institutos || (ofereceResgateParcial && institutos.length < 5)) {
      errorMessage("Institutos inválidos. Deveriam constar ao menos 5.");
      return;
    }

    let tipoInstitutoResgate: ITipo | undefined = listTipoInstituto.find((i) => i.nome === "RESGATE");

    let institutoResgateIntegral: IInstituto | undefined = institutos.find((i) => i.tipoInstitutoId === tipoInstitutoResgate?.id && !i.resgateParcial);

    if (!institutoResgateIntegral) {
      errorMessage("Institutos de resgate não localizado.");
      return;
    }

    if (caracteristica === 2) {
      if (!institutoResgateIntegral.carencia || institutoResgateIntegral.carencia === 0) {
        errorMessage("Carência obrigatória para plano instituidor.");
        return;
      }

      // carência em dias.
      if ((!institutoResgateIntegral.carencia || institutoResgateIntegral.carencia < 1080) && institutoResgateIntegral.unidadeMedidaCarencia == 1) {
        errorMessage("Carência mínima obrigatória para plano instituidor.");
        return;
      }

      // carência em meses.
      if ((!institutoResgateIntegral.carencia || institutoResgateIntegral.carencia < 36) && institutoResgateIntegral.unidadeMedidaCarencia == 3) {
        errorMessage("Carência mínima obrigatória para plano instituidor.");
        return;
      }

      // carência em anos.
      if ((!institutoResgateIntegral.carencia || institutoResgateIntegral.carencia < 3) && institutoResgateIntegral.unidadeMedidaCarencia == 5) {
        errorMessage("Carência mínima obrigatória para plano instituidor.");
        return;
      }
    }


    form
      .validateFields()
      .then(() => {
        sendForm();
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido");
      });

  };

  const sendForm = async () => {
    const currentForm = form.getFieldsValue();

    setTipLoading("Salvando dados ...");
    setLoading(true);

    const jsonPlano: IPlanoBeneficios =
    {
      numero: "",
      serie: -1,

      nome: currentForm.nome,
      sigla: sigla,
      caracteristica: caracteristica,
      modalidade: modalidade,
      fundamentacaoLegal: fundamentacaoLegal,
      tipoRegulamento: tipoRegulamento,
      codigoModelo: codigoModelo,
      contribuicaoMinima: brToNumber(contribuicaoMinima),
      unidadeMedidaContribuicaoMinima: unidadeMedidaContribuicaoMinima,
      permiteAdesaoDependente: permiteAdesaoDependente,
      indicadorPrevidencial: indicadorPrevidencial,
      preveInscricaoAutomatica: preveInscricaoAutomatica,
      limiteMaximoSalario: limiteMaximoSalario,
      preveContribuicaoMinima: preveContribuicaoMinima,

      contribuicaoNormalAssistido: contribuicaoNormalAssistido,
      contribuicaoNormalParticipante: contribuicaoNormalParticipante,
      contribuicaoNormalPatrocinador: contribuicaoNormalPatrocinador,

      contribuicaoDespesaAdministrativaAssistido: contribuicaoDespesaAdministrativaAssistido,
      contribuicaoDespesaAdministrativaParticipante: contribuicaoDespesaAdministrativaParticipante,
      contribuicaoDespesaAdministrativaPatrocinador: contribuicaoDespesaAdministrativaPatrocinador,

      contribuicaoServicoPassadoAssistido: contribuicaoServicoPassadoAssistido,
      contribuicaoServicoPassadoParticipante: contribuicaoServicoPassadoParticipante,
      contribuicaoServicoPassadoPatrocinador: contribuicaoServicoPassadoPatrocinador,

      ofereceResgateParcial: ofereceResgateParcial || false,

      numeroEfpc: dadosPlano?.efpc?.numero || "",
      numeroPessoaJuridica: currentForm.cnpjNumero && currentForm.cnpjNumero !== "" ? onlyNumbers(currentForm.cnpjNumero) : dadosPlano?.pessoaJuridicaPlano?.numero ? dadosPlano?.pessoaJuridicaPlano?.numero : "",

      dataVigencia: dayjs().format("YYYY-MM-DD"),
      dataInicioFuncionamento: currentForm.dataInicioFuncionamento ? dayjs(currentForm.dataInicioFuncionamento).format("YYYY-MM-DD") : "",

      justificativaAtualizacao: currentForm.justificativaVersionamento,

      beneficios: beneficios.map((e: IBeneficio) => {
        return {
          ...e
        };
      }),
      institutos: institutos.map((e: IInstituto) => {
        return {
          ...e
        };
      }),
      documentos: [
        ...(planoRegulamentoDocumento ?? []),
        ...(planoDocumentoOutros ?? []),
        ...(planoDocumentoAnalise ?? [])
      ].map((e: IDocumento) => ({ ...e })),

    }


    try {
      let query = `/versionar/${dadosPlano?.serie}/serie`;
      const { data } = await apiPlanosBeneficios.post(query, jsonPlano);
      setLoading(false);

      successMessage(
        `Entidade ${form?.getFieldValue("sigla")} (${maskCNPB(form.getFieldValue("numero"))}) versionada com Sucesso`
      );
      setManter(2);
      setDadosPlano(data);

    } catch (error: any) {
      let data: IErroApi = error.response.data;
      let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
      let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
      setEstadoErroApi(error.response.status);
      setMsgErroApi(msgErro + msgDetalheErro);
      if (error.response.status < 500) {
        setErroApi(data);
      } else {
        if (error.response.status === 503)
          errorMessage("Servidor remoto não disponível");
        else
          errorMessage(msgErro);
      }
      setLoading(false);
    }

  };

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    form.setFieldsValue({
      idEfpc: undefined,
      idPessoaJuridica: undefined,
      dtInicioAtuacao: undefined,
      dtFimAtuacao: undefined,
      campoServidorPublico: undefined,
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  const validarVersionar = () => {
    if (dadosPlano?.pessoaJuridicaPlano?.tipoIdentificador === 3) { // Número de processo.
      infoMessage("Esse Plano de Benefícios só pode ser versionado se houver a alteração do Número de Processo para CNPJ como o tipo de identificador da Pessoa Jurídica ");
    }
  };

  const carregaListaTiposBeneficiosOpcoes = async () => {
    // let listaLocal: any = [];
    await carregaListaTipoBeneficio().then((response) => {
      // response.data.forEach((p: ITipo) => {
      //   listaLocal.push({ value: p.id, label: p.nome });
      // });
      setListTipoBeneficio(response.data);
    });
  }

  const carregaListaTiposRegrasCalculosOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoRegraCalculo().then((response) => {
      response.data.forEach((p: ITipo) => {
        listaLocal.push({ key: p.id, label: p.nome });
      });
      setListTipoRegraCalculo(listaLocal);
    });
  }

  const carregaListaTiposRequisitosElegibilidadeOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoRequisitoElegibilidade().then((response) => {
      response.data.forEach((p: ITipo) => {
        listaLocal.push({ key: p.id, label: p.nome });
      });
      setListTipoRequisitoElegibilidade(listaLocal);
    });
  }

  const carregaListaTiposInstitutosOpcoes = async () => {
    //    let listaLocal: any = [];
    await carregaListaTipoInstituto().then((response) => {
      // response.data.forEach((p: ITipo) => {
      //   listaLocal.push({ id: p.id, label: p.nome });
      // });
      setListTipoInstituto(response.data);
    });
  }

  const carregaListaTiposComponentesResgatePortabilidadeOpcoes = async () => {
    //    let listaLocal: any = [];
    await carregaListaTipoComponenteResgatePortabilidade().then((response) => {
      // response.data.forEach((p: ITipoComponenteResgatePortabilidade) => {
      //   listaLocal.push({ key: p.id, label: p.nome, resgateIntegral: p.resgateIntegral, resgateParcial: p.resgateParcial, portabilidade: p.portabilidade, planoPatrocinado: p.planoPatrocinado, planoInstituido: p.planoInstituido });
      // });
      setListTipoComponenteResgatePortabilidade(response.data);
    });
  }

  const carregaListaTiposRegulamentosOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoRegulamento().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
      setListTipoRegulamento(listaLocal);
    });
  }

  const carregaListaDocumentoRegulamentoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("1126999422668802").then((response) => {
      if (response.data.length === 0) {
        errorMessage("Não foi possível recuperar o tipo de documento do regulamento");
      } else {
        setCtrlDocRegulamentoPlano(response.data);
        response.data.forEach((p: ICtrlDoc) => {
          listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
        });
      }
    });
    setListDocumentoRegulamentoPlano(listaLocal);
  }

  const carregaListaDocumentosOutrosPlanoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("2252899329528834").then((response) => {
      setCtrlDocsOutrosPlano(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosOutrosPlano(listaLocal);
  }

  const carregaListaDocumentosAnaliseOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("4504699143222273").then((response) => {
      setCtrlDocsAnalisePlano(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosAnalise(listaLocal);
  }


  const carregaListaFundamentacaoLegalOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaFundamentacaoLegal().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListFundamentacaoLegal(listaLocal);
  }

  const carregaListaCaracteristicasOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaCaracteristica().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListCaracteristicas(listaLocal);
  }

  const carregaListaModalidadesOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaModalidade().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListModalidades(listaLocal);
  }

  const carregaListaUnidadesMedidaPercentualMonetarioOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaUnidadeMedidaPercentualMonetario().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListUnidadesMedidaContribuicaoMinima(listaLocal);
  }

  const carregaListaUnidadesMedidaPrazoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaUnidadeMedidaPrazo().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListUnidadesMedidaCarencia(listaLocal);
  }


  const carregaListaRegimeFinanceiroOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaRegimeFinanceiro().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListRegimeFinanceiro(listaLocal);
  }

  const carregaListaMetodoFinanciamentoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaMetodoFinanciamento().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListMetodoFinanciamento(listaLocal);
  }

  const carregaListaTipoExpressaoBeneficioOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoExpressaoBeneficio().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListTipoExpressaoBeneficio(listaLocal);
  }

  const carregaListaPrazoPagamentoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaPrazoPagamento().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListPrazoPagamento(listaLocal);
  }

  const carregaListaConvenioDeAdesao = async () => {
    const lQuery = `/consulta/serie-plano?serie-plano=${dadosPlano?.serie}&page-size=100&page=0`;
    const { data } = await apiConvenio.get(lQuery);
    setConvenios(data.content);
  }

  const handleFundamentacaoLegal = async (fundamentacaoLegal: any) => {
    form.setFieldsValue({
      nmFundamentacaoLegal: fundamentacaoLegal.label,
    });
    setFundamentacaoLegal(fundamentacaoLegal.value);
  };

  const handleCaracteristica = async (caracteristica: any) => {
    form.setFieldsValue({
      nmCaracteristica: caracteristica.label,
    });
    setCaracteristica(caracteristica.value);
  };

  const handleModalidade = async (modalidade: any) => {
    form.setFieldsValue({
      nmModalidade: modalidade.label,
    });
    setModalidade(modalidade.value);
  };

  const handleUnidadeMedidaContribuicaoMinima = async (undMed: any) => {
    form.setFieldsValue({
      nmUnidadeMedidaContribuicaoMinima: undMed.label,
    });
    setUnidadeMedidaContribuicaoMinima(undMed.value);
  };

  const onChangeAdesaoDependentes: CheckboxProps['onChange'] = (e) => {
    setPermiteAdesaoDependente(e.target.checked);
  };

  const onChangeInscricaoAutomatica: CheckboxProps['onChange'] = (e) => {
    setPreveInscricaoAutomatica(e.target.checked);
  };

  const onChangeSalarioMaximo: CheckboxProps['onChange'] = (e) => {
    setLimiteMaximoSalario(e.target.checked);
  };

  const onChangeContribuicaoMinima: CheckboxProps['onChange'] = (e) => {
    setPreveContribuicaoMinima(e.target.checked);
  };

  const onChangeResgateParcial: CheckboxProps['onChange'] = (e) => {
    setOfereceResgateParcial(e.target.checked);
  };

  const handlerTipoRegulamento = (tpReg: any) => {
    setTipoRegulamento(tpReg.value);
    setNmTipoRegulamento(tpReg.label);
    form.setFieldsValue({
      "nmTpRegulamento": tpReg.label.toUpperCase(),
    })

    form.resetFields([
      "codigoModelo",
    ]);
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Regulamento',
      icon: <FontAwesomeIcon icon={faBalanceScale} />,
      children:
        <>
          <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >
            <Row>
              <Col xs={24} sm={8}>
                <Form.Item label="Tipo de Regulamento"
                  labelAlign="left"
                  labelCol={{ span: 20 }}
                  name="nmTpRegulamento"
                  colon={false}
                  rules={[
                    {
                      required: manter !== 2 ? true : false,
                      message: "Selecione o Tipo de Regulamento",
                    },
                  ]}
                >
                  <Select
                    disabled={manter === 2 ? true : false}
                    placeholder="Tipo de Regulamento"
                    showSearch
                    filterOption
                    optionFilterProp='children'
                    options={listTipoRegulamento}
                    onChange={(_, index) => {
                      handlerTipoRegulamento(index);
                    }}
                  />

                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item label="Código do Modelo"
                  name="codigoModelo"
                  colon={false}
                  rules={[
                    {
                      required: manter !== 2 ? nmTipoRegulamento.includes("MODELO") ? true : false : false,
                      message: "Preencha o Código do Modelo",
                    },
                  ]}
                >
                  <Input
                    disabled={manter === 2 ? true : !nmTipoRegulamento.includes("MODELO") ? true : false}
                    onBlur={(e) => {
                      setCodigoModelo(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <FormModalDocumento
            ctrlDoc={ctrlDocRegulamentoPlano}
            objetoDocumento={planoRegulamentoDocumento}
            setObjetoDocumento={setPlanoRegulamentoDocumento}
            listaDocumentos={listDocumentoRegulamentoPlano}
            manter={manter}
          />
        </>
    },
    {
      key: '1-hist',
      label: 'Regulamentos Históricos',
      icon: <FontAwesomeIcon icon={faClockRotateLeft} />,
      children:
        <FormModalDocumento
          ctrlDoc={ctrlDocRegulamentoPlano}
          objetoDocumento={documentosRegulamentosHistoricos}
          setObjetoDocumento={setDocumentosRegulamentosHistoricos}
          listaDocumentos={listDocumentoRegulamentoPlano}
          manter={2}
        />
    },
    {
      key: '2',
      label: 'Contribuições',
      icon: <FontAwesomeIcon icon={faPiggyBank} />,
      children:
        <>
          <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >
            <Row>
              <Col xs={24} md={12} xl={10}>
                <Checkbox
                  disabled={manter === 2 ? true : false}
                  checked={limiteMaximoSalario}
                  onChange={onChangeSalarioMaximo}
                >
                  Existe Limite Máximo de Salário de Contribuição/Participação
                </Checkbox>
              </Col>

              <Col xs={24} md={12} xl={6}>
                <Checkbox
                  disabled={manter === 2 ? true : false}
                  checked={preveContribuicaoMinima}
                  onChange={onChangeContribuicaoMinima}
                >
                  Prevê Contribuição Mínima
                </Checkbox>
              </Col>

              <Col xs={24} xl={4}>
                <Form.Item
                  label="Contribuição Mínima"
                  name="contribuicaoMinima"
                  rules={[
                    {
                      required: manter !== 2 ? preveContribuicaoMinima : false,
                      message: "Preencha a Contribuição Mínima",
                    },
                  ]}                >
                  <Input
                    disabled={manter === 2 ? true : !preveContribuicaoMinima}
                    onChange={(e) =>
                      form.setFieldsValue({
                        contribuicaoMinima: maskCurrency(e.target.value),
                      })
                    }
                    onBlur={(e) => {
                      setContribuicaoMinima(maskCurrency(e.target.value));
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} xl={4}>
                <Form.Item
                  label="Unidade de Medida"
                  name="nmUnidadeMedidaContribuicaoMinima"
                  rules={[
                    {
                      required: manter !== 2 ? preveContribuicaoMinima : false,
                      message: "Selecione a Unidade de Medida",
                    },
                  ]}
                >
                  <Select
                    disabled={manter === 2 ? true : !preveContribuicaoMinima}
                    showSearch filterOption optionFilterProp='children'
                    placeholder="Unidade de Medida"
                    options={listUnidadesMedidaContribuicaoMinima}
                    onChange={(_, index) => {
                      handleUnidadeMedidaContribuicaoMinima(index);
                    }}
                  />
                </Form.Item>
              </Col>

            </Row>
          </Form>

          <FormContribuicao
            initialState={{
              "Contribuição Normal-Participante": contribuicaoNormalParticipante,
              "Contribuição Normal-Assistido": contribuicaoNormalAssistido,
              "Contribuição Normal-Patrocinador": contribuicaoNormalPatrocinador,

              "Contribuição p/ Despesas Administrativas-Participante": contribuicaoDespesaAdministrativaParticipante,
              "Contribuição p/ Despesas Administrativas-Assistido": contribuicaoDespesaAdministrativaAssistido,
              "Contribuição p/ Despesas Administrativas-Patrocinador": contribuicaoDespesaAdministrativaPatrocinador,

              "Contribuição p/ Serviço Passado-Participante": contribuicaoServicoPassadoParticipante,
              "Contribuição p/ Serviço Passado-Assistido": contribuicaoServicoPassadoAssistido,
              "Contribuição p/ Serviço Passado-Patrocinador": contribuicaoServicoPassadoPatrocinador,
            }}
            setContribuicaoNormalParticipante={setContribuicaoNormalParticipante}
            setContribuicaoNormalAssistido={setContribuicaoNormalAssistido}
            setContribuicaoNormalPatrocinador={setContribuicaoNormalPatrocinador}

            setContribuicaoPDespesasAdministrativasParticipante={setContribuicaoDespesaAdministrativaParticipante}
            setContribuicaoPDespesasAdministrativasAssistido={setContribuicaoDespesaAdministrativaAssistido}
            setContribuicaoPDespesasAdministrativasPatrocinador={setContribuicaoDespesaAdministrativaPatrocinador}

            setContribuicaoPServicoPassadoParticipante={setContribuicaoServicoPassadoParticipante}
            setContribuicaoPServicoPassadoAssistido={setContribuicaoServicoPassadoAssistido}
            setContribuicaoPServicoPassadoPatrocinador={setContribuicaoServicoPassadoPatrocinador}
            manter={manter}
          />
        </>
    },
    {
      key: '3',
      label: 'Benefícios',
      icon: <FontAwesomeIcon icon={faGift} />,
      children:
        <Beneficio
          form={form}
          objetoBeneficio={beneficios}
          setObjetoBeneficio={setBeneficios}
          listTiposBeneficios={listTipoBeneficio}
          listRegimeFinanceiro={listRegimeFinanceiro}
          listMetodoFinanciamento={listMetodoFinanciamento}
          listTipoExpressaoBeneficio={listTipoExpressaoBeneficio}
          listPrazoPagamento={listPrazoPagamento}
          listTipoRegraCalculo={listTipoRegraCalculo}
          listTipoRequisitoElegibilidade={listTipoRequisitoElegibilidade}
          manter={manter}
        />
    },
    {
      key: '4',
      label: 'Institutos',
      icon: <FontAwesomeIcon icon={faHandHoldingDollar} />,
      children:
        <>
          <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form}>
            <Row>
              <Col xs={24} md={12} xl={10}>
                <Checkbox
                  disabled={manter === 2 ? true : false}
                  checked={ofereceResgateParcial}
                  onChange={onChangeResgateParcial}
                >
                  Plano oferece resgate parcial
                </Checkbox>
              </Col>
            </Row>

          </Form>

          <Instituto
            form={form}
            institutos={institutos}
            setInstitutos={setInstitutos}
            caracteristica={caracteristica}
            resgateParcial={ofereceResgateParcial}
            listTiposInstitutos={listTipoInstituto}
            listTiposComponentes={listTipoComponenteResgatePortabilidade}
            listUnidadesMedida={listUnidadesMedidaCarencia}
            manter={manter} />
        </>
    },
    {
      key: '5',
      label: 'Convênio de Adesão',
      icon: <FontAwesomeIcon icon={faHandshake} />,
      children:
        <>
          <ListarConveniosAdesao
            convenios={convenios}
            manter={manter}
            setLoading={setLoading}
            setTipLoading={setTipLoading}
          />
        </>
    },
    {
      key: '5-2',
      label: 'Patrocinadores',
      icon: <FontAwesomeIcon icon={faHandshake} />,
      children:
        <>
          <ListarConvenentesConvenioAdesao
            convenentesComConvenios={convenentesComConvenios}
            manter={manter}
            setLoading={setLoading}
            setTipLoading={setTipLoading}
          />
        </>
    },
    {
      key: '6',
      label: 'Outros Documentos do Plano',
      icon: <FontAwesomeIcon icon={faIdCard} />,
      children:
        <FormModalDocumento
          ctrlDoc={ctrlDocsOutrosPlano}
          objetoDocumento={planoDocumentoOutros}
          setObjetoDocumento={setPlanoDocumentoOutros}
          listaDocumentos={listDocumentosOutrosPlano}
          manter={manter}
        />
    },
    {
      key: '7',
      label: 'Documentação de Análise/Autorização',
      icon: <FontAwesomeIcon icon={faIdCardAlt} />,
      children:
        <FormModalDocumento
          ctrlDoc={ctrlDocsAnalisePlano}
          objetoDocumento={planoDocumentoAnalise}
          setObjetoDocumento={setPlanoDocumentoAnalise}
          listaDocumentos={listDocumentosAnalise}
          manter={manter}
        />
    },
  ];


  return (
    <>
      {/* <Prompt
        when={idEfpc !== undefined && idEfpc !== 0}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>

        <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >

          <div className="main-content pl-sm-3 mt-4">
            <h1>{
              (() => {
                switch (manter) {
                  case 1:
                    return "Cadastrar Plano de Benefícios"
                  case 2:
                    return "Detalhar Plano de Benefícios"
                  case 3:
                    return "Versionar Plano de Benefícios"
                  default:
                    return null
                }
              })()}
            </h1>
          </div>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações da Entidade</h2>
          </div>

          <Row>
            <Col xs={24} xl={5}>
              <Form.Item
                label="CNPJ"
                name="efpcNumeroEfpcCnpj">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Número do processo"
                name="efpcNumeroProcesso">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format={numeroProcessoEfpcFormato}
                />
              </Form.Item>

            </Col>

            <Col xs={24} md={12} xl={9}>
              <Form.Item label="Razão Social"
                name="efpcRazaoSocial">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={4} >
              <Form.Item style={{ alignItems: 'center' }}
                label={"Detalhar Cadastro da Entidade"}
              >
                <Button
                  shape='round'
                  onClick={() => {
                    setMostrarDetalhesEfpc(!mostrarDetalhesEfpc);
                  }}
                  type='primary'
                  icon={<UserOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>

          <ModalEfpc
            dadosEfpc={dadosEfpc}
            modalEfpcSucessoAberto={mostrarDetalhesEfpc}
            setModalEfpcSucessoAberto={setMostrarDetalhesEfpc}
          />

          <div className="main-content pl-sm-3 mt-4">
            <h2>Perfil do Plano de Benefícios</h2>
          </div>

          <Row>
            <Col xs={24} md={12} xl={5} hidden={dadosPlano?.pessoaJuridicaPlano?.tipoIdentificador === 3}>
              <Form.Item
                label="CNPJ"
                name="planoNumeroEfpcCnpj">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={7} hidden={dadosPlano?.pessoaJuridicaPlano?.tipoIdentificador !== 3}>
              <Form.Item
                label="Identificador Provisório (Processo)"
                name="planoNumeroEfpcProcesso">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format={numeroProcessoPlanoFormato}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={7} hidden={dadosPlano?.pessoaJuridicaPlano?.tipoIdentificador !== 3}>
              <Form.Item
                label='CNPJ'
                name='cnpjNumero'>
                <Input maxLength={18}
                  disabled={manter === 2 ? true : false}
                  onChange={(e) =>
                    form.setFieldsValue({
                      cnpjNumero: maskCnpj(e.target.value),
                    })
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6} hidden={dadosPlano?.pessoaJuridicaPlano?.tipoIdentificador === 3}>
              <Form.Item
                label="Número do processo"
                name="numeroProcesso">
                <PatternFormat
                  customInput={Input}
                  format={numeroProcessoPlanoFormato}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={12}>
              <Form.Item
                label="Situação"
                name="nmSituacao">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data da Situação"
                name="dataSituacao">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data da Autorizacao"
                name="dataAutorizacao"
              >
                <Input disabled />
              </Form.Item>
            </Col>


            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data de início de Funcionamento"
                name="dataInicioFuncionamento">
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabled={manter === 2 ? true : dadosPlano && dadosPlano.dataInicioFuncionamento ? true : false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data de Encerramento"
                name="dataEncerramento"
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Código"
                name="numero"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Sigla"
                name="sigla"
                rules={[
                  {
                    required: manter !== 2 ? true : false,
                    message: "Preencha a Sigla do Plano",
                  },
                ]}
              >
                <Input
                  disabled
                  onBlur={(e) => {
                    setSigla(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={14}>
              <Form.Item
                label="Nome"
                name="nome"
                rules={[
                  {
                    required: manter !== 2 ? true : false,
                    message: "Preencha o Nome do Plano",
                  },
                ]}
              >
                <Input
                  disabled={manter === 2 ? true : false}
                />
              </Form.Item>
            </Col>

          </Row>

          <Row>
            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Característica"
                name="nmCaracteristica"
                rules={[
                  {
                    required: manter !== 2 ? true : false,
                    message: "Selecione uma Característica",
                  },
                ]}
              >
                <Select
                  disabled={manter === 2 ? true : false}
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Característica"
                  options={listCaracteristicas}
                  onChange={(_, index) => {
                    handleCaracteristica(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={10}>
              <Checkbox
                disabled={manter === 2 ? true : false}
                checked={permiteAdesaoDependente}
                onChange={onChangeAdesaoDependentes}
              >
                Permite Adesão de Dependentes
              </Checkbox>
            </Col>

          </Row>

          <Row>
            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Modalidade"
                name="nmModalidade"
                rules={[
                  {
                    required: manter !== 2 ? true : false,
                    message: "Selecione a Modalidade do Plano",
                  },
                ]}
              >
                <Select
                  disabled={manter === 2 ? true : false}
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Modalidade"
                  options={listModalidades}
                  onChange={(_, index) => {
                    handleModalidade(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Fundamentação Legal"
                name="nmFundamentacaoLegal"
                rules={[
                  {
                    required: manter !== 2 ? true : false,
                    message: "Fundamentação Legal obrigatório não preenchido",
                  },
                ]}
              >
                <Select
                  disabled={manter === 2 ? true : false}
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Fundamentação Legal"
                  options={listFundamentacaoLegal}
                  onChange={(_, index) => {
                    handleFundamentacaoLegal(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={10}>
              <Checkbox
                disabled={manter === 2 ? true : false}
                checked={preveInscricaoAutomatica}
                onChange={onChangeInscricaoAutomatica}
              >
                Prevê Inscrição Automática
              </Checkbox>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={24} hidden={manter !== 3}>
              <Form.Item
                label="Justificativa do Versionamento"
                name="justificativaVersionamento"
                rules={[
                  {
                    required: manter !== 2 ? true : false,
                    message: "Preencha a justificativa do versionamento",
                  },
                ]}
              >
                <TextArea
                  onChange={(e) =>
                    form.setFieldsValue({
                      justificativaVersionamento: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>


        </Form>

        <Tabs
          defaultActiveKey="1"
          items={items}
        // onChange={onChange} 
        />


        <Form layout='vertical' style={{ padding: 24 }} onFinish={validarPlanoBeneficio} onFinishFailed={onFinishFailed} scrollToFirstError form={form} >

          <CadInfoBotoes
            resetForm={resetForm}
            detalhar={false}
            form={form}
            resetColor={resetColor}
            setManter={setManter}
            manter={manter}
            msgConfirmacao={`Novo Plano: ${sigla}`}
            rotaConsultar={"/" + import.meta.env.VITE_APP_BASE + "/plano-consultar"}
          />

        </Form >
      </Spin >

    </>
  );
};

export default Manter;